/* eslint-disable no-console */
import Global from '../../global';

const PubSub = (function() {
  let instance;

  function init(channelDefinitions) {
    return {
      channels: channelDefinitions,
      publishTopicToChannel: function(
        channel = {},
        topic = {},
        data,
        headers
      ) {
        // used console instead of logger because tests are failing with logger
        // as it's not initialized at tests run time
        const dataToLog = data ? JSON.stringify(data) : 'no';
        const headersToLog = headers ? JSON.stringify(headers) : 'no';
        console.log(
          `MESSAGE SENT ***  ${channel.channel} channel | ${topic.name} topic | ${dataToLog} data | ${headersToLog} headers`
        );

        try {
          topic.publish(headers, data);
        } catch (error) {
          Global.logger.error(`Publish topic ${topic.name} to channel ${channel.channel} failed. ${error}`);
        }
      }
    };
  }

  return {
    get: function() {
      return instance;
    },
    set: function(channels) {
      instance = init(channels);
    }
  };
})();

export default PubSub;
